export default __webpack_public_path__ + "static/media/house-13.5a4bd281.jpg";